module.exports = __webpack_public_path__ + "img/768_stores_img4.9f95ccff.png";